import { Entity } from "@dinahmoe/dmafjs-core";

class ConditionalDispatcher extends Entity {
  ALWAYS = "ALWAYS";
  namespace = "control:conditionalDispatcher";

  init(node) {
    // TODO will require refactoring to support duýnamic values in conditions, please see scaler
    this.log("conditionalDispatcher", node.uid, "instantiated");
    node.lastEvent = "";
  }

  execute(node, config, event) {
    // change in v20, untested
    node.props = config;

    this.log("destination", event.name, node.props.checkProperty);
    this.doCheckProperty(node, event);
  }

  doCheckProperty(node, event) {
    for (const condition of node.props.conditions) {
      if (this.match(node.props.checkProperty, condition)) {
        if (
          node.props.doDispatch === this.ALWAYS ||
          condition.outEvent !== node.lastEvent
        ) {
          this.log(event.name, "dispatching", condition.outEvent);
          this.dispatch(condition.outEvent, event.time, event.data);
          node.lastEvent = condition.outEvent;
        }
        break;
      }
    }
  }

  match(value, condition) {
    const compareWith = condition.compareWith;
    const operator = condition.operator;

    if (value === undefined || compareWith === undefined) {
      return false;
    }
    if (compareWith === "any") {
      return true;
    } else {
      switch (operator) {
        case "==":
          return value === compareWith;
        case "!=":
          return value !== compareWith;
        case ">":
          return value > compareWith;
        case ">=":
          return value >= compareWith;
        case "<":
          return value < compareWith;
        case "<=":
          return value <= compareWith;
      }
    }
  }
}

const conditionalDispatcher = new ConditionalDispatcher();
export { conditionalDispatcher, ConditionalDispatcher };
